import { render, staticRenderFns } from "./componentColor.vue?vue&type=template&id=691d2436&scoped=true"
import script from "./componentColor.vue?vue&type=script&lang=js"
export * from "./componentColor.vue?vue&type=script&lang=js"
import style0 from "./componentColor.vue?vue&type=style&index=0&id=691d2436&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./componentColor.vue?vue&type=style&index=1&id=691d2436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691d2436",
  null
  
)

export default component.exports